import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Component";
import Sidebar from "../components/sidebar/Component";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  let BrandName = "Restaurant App";

  return (
    <div className="container-fluid side-padd layout">
      <div className="row main-parent">
        <div className="col_parent_class col-xl-2 col-lg-3 first_child_width main-container">
          <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} toggleSidebar={toggleSidebar} brandName={BrandName} />
        </div>
        <div className="col_parent_class col-xl-10 col-lg-9 second_child_width content">
          <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} brandName={BrandName} />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
